import {videoDataLayers} from "../helpers";

$(document).ready(function() {

    let $element = $('.product-main-video-wrapper video')
    let $elementMobile = $('.product-main-video-wrapper-mobile video')

    if($element.length){
        $element.click(function(){
            this.paused? this.play() : this.pause();
        })

        videoDataLayers($element[0]);
    }

    if($elementMobile.length){
        $elementMobile.click(function(){
            this.paused? this.play() : this.pause();
        })

        videoDataLayers($elementMobile[0]);
    }

    window.addEventListener('resize', function(){

        $('.product-main-video-wrapper video, .product-main-video-wrapper-mobile video').each(function(){
            if(!this.paused){
                this.pause()
            }
        })
    })

})